import React from 'react';

import Sentiment from './Sentiment';
import './InterviewList.css';

const SentimentList = props => {
    if (!props.items || props.items.length === 0) {
      return <div><p>No response detected.</p></div>
    }

    return (
      <div className='sentiment-scroll' >
      <ul className="interview-list-sentiment">
        {props.items.map(sentiment => (
          <Sentiment
            key={sentiment.id}
            id={sentiment.id}
            text={sentiment.text}
            start={sentiment.start}
            end={sentiment.end}
            confidence={sentiment.confidence}
            sentiment={sentiment.sentiment}
            onClick={props.onClickSentiment}
          />
        ))}
      </ul>
      </div>
    );
  };
  
  export default SentimentList;